"use client"

import { CreateEspeceForm } from "./components/create-espece-form";
import { EditEspeceForm } from "./components/edit-espece-form";

interface EspeceFormProps {
  id?: string;
  especeId?: number;
  onCancel: () => void;
  onSuccess: () => void;
}

export function EspeceForm({ id, especeId, onCancel, onSuccess }: EspeceFormProps) {
  // Check if we're in edit mode by looking for either id or especeId
  const isEditing = !!id || !!especeId;

  if (isEditing) {
    return (
      <EditEspeceForm
        id={id || especeId?.toString() || ""}
        onCancel={onCancel}
        onSuccess={onSuccess}
      />
    );
  }

  return (
    <CreateEspeceForm
      onCancel={onCancel}
      onSuccess={onSuccess}
    />
  );
}
